
import {CollectionViewer, DataSource} from "@angular/cdk/collections";
import { Observable, BehaviorSubject, of } from "rxjs";
import { catchError, finalize } from 'rxjs/operators';
import { ProductDto, ProductServiceProxy, WarehouseDto, ProductDomainWarehouseInput } from "../../../../../../shared/service-proxies/service-proxies";

//Product

export class FilterForProduct {
    maxResultCount: number = 10; //PerPage
    pageIndex: number = 0;
    isActive?: boolean;
    sorting: string;
    keyword: string ;;
    brands: number[] ;
    channels: number[] ;
    productTypes: string[] ;
    businessUnits : number[] = [];
	warehouses: ProductDomainWarehouseInput[] = [];

    //diger kriterleri buraya ekleyerek genisletebilirsin.
}

export class ProductDataSource implements DataSource<ProductDto> {

    private productSubject = new BehaviorSubject<ProductDto[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private hasItemsSubject = new BehaviorSubject<boolean>(false);
    private totalCount = new BehaviorSubject<number>(0);
    

    public loading$ = this.loadingSubject.asObservable();
    public hasItems$ = this.hasItemsSubject.asObservable();
    public totalCount$ = this.totalCount.asObservable();
    public productList$ = this.productSubject.asObservable();

    constructor (
        private _productService : ProductServiceProxy
    ){
        
    }   

    connect(collectionViewer: CollectionViewer): Observable<ProductDto[]> {
        return this.productSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.productSubject.complete();
        this.loadingSubject.complete();
        this.hasItemsSubject.complete();
    }

//     /**
//      * Listeyi servisten alir.
//      * @param filterKeyword Aranan bir kelime
//      * @param isActive 
//      * @param sorting "Id DESC", "userName ASC" gibi alan ve sort tipi seklinde string ifade alir
//      * @param maxResultCountPerPage Bir sayfada gorunecek kayit sayisi
//      * @param pageIndex Kacinci sayfadaki veriler goruntulenmek isteniyor.
//      */
// loadData(filter: FilterForProduct){
//         //Loading basliyor...
//         this.loadingSubject.next(true);
        
         
       
//         const skipCount = filter.pageIndex * (filter.maxResultCount ? filter.maxResultCount : 0);

//         this._productService.getAllWithStock(
//                 filter.keyword, 
//                 filter.sorting, 
//                 // filter.brands,
//                 // filter.businessUnits,
//                 // filter.channels,
//                 // filter.types, 
//                 skipCount, 
//                 filter.maxResultCount
//             )
//         .subscribe(
//             products => 
//             {
//                 this.productSubject.next(products.items)
//                 this.totalCount.next(products.totalCount);
//                 this.hasItemsSubject.next(products.items.length > 0);

//             },

//             (err) => {}, //Error
//             () => {      //OnComplete
//                 this.loadingSubject.next(false);
                
//             }
//         )
//     }


	/**
     * Sayfalama isleminden bagimsiz olarak tum datayi verir.
     * Excel'e aktarirken kullanilir.
     * Sortlama ve diger arama kriterleri gecerli olarak data alinir. Sadece sayfalama haric tutulmustur.
     * @param keyword 
     * @param sorting 
     * @param isActive 
     */
loadAllData(filter: FilterForProduct) {
        //return this._productService.getAllForExcel(filter.keyword, filter.sorting,  filter.isActive, 0, 10000);
    }
}
